var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.editMode)?_c('v-academy-list',{on:{"handleEditMode":_vm.handleEditMode}}):_c('v-academy-form',{attrs:{"course":_vm.course},on:{"handleEditMode":_vm.handleEditMode}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }